<div class="portal-container">
  <!-- Header -->
  <header class="portal-header">
    <div class="container">
      <div class="header-content">
        <div class="header-left">
          <div class="logo-icon">
            <img src="/assets/images/download.svg" alt="">
          </div>
          <h2 class="company-title">
            ACA SHIPPING
          </h2>
        </div>

      </div>
    </div>
  </header>

  <!-- Invalid Link Message -->
  <main class="portal-main" *ngIf="!isValidLink && !isSuccess">
    <div class="container">
      <div class="error-container" style="text-align: center; padding: 60px 20px;">
        <div
          style="background-color: #fee; border: 2px solid #fcc; border-radius: 12px; padding: 40px; max-width: 500px; margin: 0 auto;">
          <svg width="64" height="64" fill="#dc3545" viewBox="0 0 24 24" style="margin-bottom: 20px;">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <h2 style="color: #dc3545; margin-bottom: 15px; font-size: 24px;">Invalid Upload Link</h2>
          <p style="color: #666; font-size: 16px; line-height: 1.6;">{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </main>

  <!-- Success Message -->
  <main class="portal-main" *ngIf="isSuccess">
    <div class="container">
      <div class="success-container" style="text-align: center; padding: 60px 20px;">
        <div
          style="background-color: #d4edda; border: 2px solid #c3e6cb; border-radius: 12px; padding: 40px; max-width: 500px; margin: 0 auto;">
          <svg width="64" height="64" fill="#28a745" viewBox="0 0 24 24" style="margin-bottom: 20px;">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
          </svg>
          <h2 style="color: #28a745; margin-bottom: 15px; font-size: 24px;">Images Uploaded Successfully!</h2>
          <p style="color: #666; font-size: 16px; line-height: 1.6; margin-bottom: 10px;">Your shipping images have been uploaded successfully.</p>
          <p style="color: #666; font-size: 14px;">Thank you for your submission.</p>
        </div>
      </div>
    </div>
  </main>

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="isLoading" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); display: flex; align-items: center; justify-content: center; z-index: 9999;">
    <div style="text-align: center;">
      <div class="spinner" style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 60px; height: 60px; animation: spin 1s linear infinite; margin: 0 auto 20px;"></div>
      <p style="color: white; font-size: 18px; font-weight: 500;">Uploading images, please wait...</p>
    </div>
  </div>

  <!-- Main Content -->
  <main class="portal-main" *ngIf="isValidLink && !isSuccess">
    <div class="container">
      <div class="main-content">
        <!-- Left Side - Information -->
        <div class="info-section">
          <div class="info-content">
            <div class="security-badge">


            </div>

            <h1 class="main-title">
              Shipment {{type}} <br />
              <p class="sub-title">#VIN-{{shippingDetails?.vin | slice: -6}}</p>
            </h1>

            <h2 class="section-title">Upload Images</h2>
            <p class="description">
              Please upload the required images for your vehicle. Ensure that the images are clear and meet the
              specified requirements below.
            </p>

            <div class="requirements-list">
              <div class="requirement-item">
                <div class="check-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p>PNG or JPG image formats only</p>
              </div>
              <div class="requirement-item">
                <div class="check-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p>Maximum file size: 5MB</p>
              </div>
              <div class="requirement-item">
                <div class="check-icon">
                  <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p>Documents must be clear and legible</p>
              </div>
            </div>
          </div>


        </div>

        <!-- Right Side - Upload Area -->
        <div class="upload-section">
          <div class="upload-content">
            <!-- Upload Drop Zone -->
            <div class="drop-zone" (click)="fileInput.click()" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
              [class.drag-active]="isDragging">

              <div class="upload-icon-circle">
                <svg width="32" height="32" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                </svg>
              </div>

              <h3 class="drop-title">Drag & Drop Documents</h3>
              <p class="drop-subtitle">or click to browse from your computer</p>

              <button class="choose-btn" type="button">Choose Files</button>

              <input #fileInput type="file" accept="image/jpeg,image/jpg,image/png" multiple (change)="onFileSelected($event)" hidden>
            </div>

            <!-- Preview Grid -->
            <div class="preview-section" *ngIf="imagesArray?.length > 0">
              <h3 class="preview-title">Uploaded Files ({{imagesArray.length}})</h3>
              <div class="preview-grid">
                <div class="preview-item" *ngFor="let file of imagesArray; let i = index">
                  <img [src]="file.preview" alt="preview" *ngIf="file.type.includes('image')">
                  <div class="file-icon" *ngIf="!file.type.includes('image')">
                    <svg width="48" height="48" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                      </path>
                    </svg>
                  </div>
                  <div class="file-details">
                    <p class="file-name">{{ file.name }}</p>
                    <p class="file-size">{{ formatFileSize(file.size) }}</p>
                  </div>
                  <button class="remove-btn" (click)="removeFile(i)" type="button">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Bottom Action Bar -->
          <div class="action-bar" *ngIf="imagesArray?.length > 0">
            <div class="action-info">
              <p class="action-count">{{imagesArray.length}} files selected for submission</p>
              <p class="action-status">Ready to upload</p>
            </div>
            <div class="action-buttons">
              <button (click)="clearAll()" type="button" class="cancel-btn" [disabled]="isLoading">Cancel</button>
              <button (click)="uploadImages()" type="button" class="submit-btn" [disabled]="isLoading">
                <span *ngIf="!isLoading">Submit</span>
                <span *ngIf="isLoading">Uploading...</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>